// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TabletOutlinedSvg from "@fishx/icons-svg/es/asn/TabletOutlined";
import FishxIcon from '../components/FishxIcon';

var TabletOutlined = function TabletOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: TabletOutlinedSvg
  }));
};

TabletOutlined.displayName = 'TabletOutlined';
export default React.forwardRef(TabletOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/TabletOutlined.js
// module id = 4232
// module chunks = 0